<footer class="elevation-2" [appSetPaddingBottom]="selectorForPadding">
  <ng-content></ng-content>
</footer>
